<template>
  <div>
    <v-textarea label="Code" v-model="node.code" style="font-family: monospace, monospace;" />
  </div>
</template>

<script>

export default {
  props: {
    journey: { type: Object, required: true },
    node: { type: Object, required: true },
  },

  // data: () => ({
  // }),

  // computed: {
  // },

}
</script>

